import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Card, CardBody, CardHeader, Progress, Row, Col } from 'reactstrap';
import LoadingOverlay from './LoadingOverlay';

const INSPECTION_PROGRESS_QUERY = gql`
  query StatsInspectionProgress {
    inspectionProgress: stats_inspection_progress {
      projectId: project_id
      projectName: project_name
      inspectionName: inspection_name
      inspectionTypeId: inspection_type_id
      count
      totalRequired: total_required
      percent
    }
  }
`;

class InspectionProgressChart extends Component {
  render() {
    return (
      <Query query={INSPECTION_PROGRESS_QUERY}>
        {({ loading, error, data }) => (
          <Card>
            <CardHeader>
              <strong>Inspection Progress</strong>
            </CardHeader>
            <CardBody style={{ position: 'relative', minHeight: '150px' }}>
              {loading && <LoadingOverlay />}
              {error && <div>Error: {error.message}</div>}
              {!loading && !error && data && (() => {
                const inspections = data.inspectionProgress;
                
                const inspectionsByProject = inspections.reduce((acc, insp) => {
                  if (!acc[insp.projectId]) {
                    acc[insp.projectId] = {
                      projectName: insp.projectName,
                      inspections: []
                    };
                  }
                  acc[insp.projectId].inspections.push(insp);
                  return acc;
                }, {});

                return Object.values(inspectionsByProject).map((project, idx) => {
                  const avgPercent = Math.round(
                    project.inspections.reduce((sum, i) => sum + i.percent, 0) / project.inspections.length
                  );

                  return (
                    <div key={idx} className={idx > 0 ? 'mt-4' : ''}>
                      <h6>{project.projectName}</h6>
                      <div className="mb-3">
                        <div className="clearfix mb-1">
                          <span className="float-left">Overall Average</span>
                          <span className="float-right">{avgPercent}%</span>
                        </div>
                        <Progress value={avgPercent} color="success" />
                      </div>
                      <Row>
                        {project.inspections.map((insp, i) => (
                          <Col md="6" key={i} className="mb-2">
                            <div className="clearfix mb-1">
                              <span className="float-left text-muted small">{insp.inspectionName}</span>
                              <span className="float-right text-muted small">{insp.percent}%</span>
                            </div>
                            <Progress value={insp.percent} className="progress-xs" />
                          </Col>
                        ))}
                      </Row>
                    </div>
                  );
                });
              })()}
            </CardBody>
          </Card>
        )}
      </Query>
    );
  }
}

export default InspectionProgressChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/InspectionProgressChart.js